import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';
import confirmationMessages from '../../../shared/models/Enum/AchConfirmationMessages';

import moment from 'moment';

@Component({
  selector: 'review-deposit-funds',
  template: require('./review-deposit-funds.component.html')
})

export class ReviewDepositFundsComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
    this.reviewError = false;
    this.contributionYear = this.form.inputs.contributionYear;

    if (this.flowManager.isIra && this.contributionYear !== undefined) {
      this.contributionYear.showUp = true;
    }
    this.isTKA = this.flowManager.getAppType() === 'tka';
  }

  btnClick(e) {
    this.reviewError = false;
    if (e.action === 'submit') {
      const fundAccount = this.appActions.getData('FundAccount');
      const depositFunds = this.appActions.getData('DepositFunds');
      const accountType = this.appActions.getData('ApplicationInformation').accountType;
      const dob = this.appActions.getData('PersonalInformation.dob');
      const age = moment().diff(moment(dob, 'MM/DD/YYYY'), 'years');
      const payload = {
        amount: depositFunds.amount,
        accountNumber: fundAccount.accountNumber,
        date: depositFunds.date,
        contributionYear: depositFunds.contributionYear,
        frequency: depositFunds.frequency,
        isIRA: this.flowManager.isIra,
        allyBankBalance: '',
        repCode: this.repCodeTransform(accountType),
        accountNature: this.accountNatureTransform(accountType),
        fromSubType: fundAccount.bankAccountType,
        fromAba: fundAccount.routingNumber,
        transactionType: fundAccount.allyBankAccount ? 'RTT_DEPOSIT' : null,
        fromAccountType: fundAccount.fromAccountType,
        isUnder50: age < 50
      };

      this.modal.loadingModel();

      this.appProxy.initiateOneAllyTransfer(payload, resp => {
        if (resp.result.status === 200 && !resp.result.error && !resp.result.message) {
          const transactionId = resp.result.requestId || resp.result.scheduleId;
          this.appActions.setData('DepositFunds.requestId', transactionId);
          this.appActions.setData('DepositFunds.achTransfer', true);
          this.modal.closeModal('deposit-funds-receipt');
        } else {
          this.reviewErrorText = 'An error has occurred. Contact us at 1-855-880-2559.';
          if (resp.result.status === 417) {
            let errorMessage = resp.result.message;
            try {
              const error = JSON.parse(resp.result.message);
              errorMessage = error.errorDescription;
            } catch (error) {
              errorMessage = null;
            }
            this.reviewErrorText = errorMessage || 'An error has occurred. Contact us at 1-855-880-2559.';
          } else if (resp.result.status === 406) {
            this.reviewErrorText = confirmationMessages.get('OAT_AFTER_355');
          }
          this.reviewError = true;
          let reviewRoute = 'review-deposit-funds';
          if (this.flowManager.isIra) {
            reviewRoute = 'review-deposit-funds-ira';
          }
          this.modal.closeModal(reviewRoute);
        }
      });
    } else if (e.action === 'edit') {
      let editRoute = '/deposit-funds';
      if (this.flowManager.isIra) {
        editRoute = '/deposit-funds-ira';
      }
      this.router.navigate([editRoute]);
    }
  }

  repCodeTransform() {
    return this.appActions.getData('appType') === 'tka' ? 'R08' : 'A08';
  }

  accountNatureTransform(accountType) {
    const map = {
      'select-roth': 'I2',
      'select-traditional': 'I1',
      'select-rollover': 'I6',
      'select-individual': '05',
      'select-joint': '06',
      'select-custodial': '08'
    };
    return map[accountType];
  }
}
